import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
      {
            path: '/serverdown',
            name: 'ServerDown',
          component: () => import("./view/pages/ServerDown.vue"),
              meta: { title:  'ROUTE.TITLES.SERVER_DOWN' }

          },
    {
      path: "/",
      redirect: "/dashboard",
      meta: { main_page: true },
      component: () => import("./core/plugins/TitleRibbon/index"),
      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          meta: { main_page: true },
          component: () => import("./core/plugins/TitleRibbon/Dashboard"),
        },
        {
          path: "/admin/qr/domains",
          name: "admin.qr.domains",
          props: true,
          component: () => import("./view/pages/admin/domains"),
          meta: {
            title: "ROUTE.TITLES.ADMIN_QR_DOMAINS",
            has_ribbon: true,
            permission: "admin_qr_domains",
          },
        },
        {
          path: "/admin/together-token",
          name: "admin.together.token",
          props: true,
          component: () =>
            import("./view/pages/admin/tokens/togetherToken.vue"),
          meta: {
            title: "ROUTE.TITLES.ADMIN_TOGETHER_TOKEN",
            has_ribbon: true,
            permission: "admin_qr_domains",
          },
        },
        {
          path: "/admin/qr/sms",
          name: "admin.qr.sms",
          props: true,
          component: () => import("./view/pages/admin/adminSendSms"),
          meta: {
            title: "ROUTE.TITLES.ADMIN_QR_SMS",
            has_ribbon: true,
            permission: "qr_send_sms",
          },
        },
        {
          path: "/menu/profile",
          name: "menu.profile",
          meta: { main_page: true },
          component: () => import("./view/pages/menu/profile"),
          children: [
            {
              path: "/",
              name: "menu.profile.info",
              meta: { main_page: true },
              component: () => import("./view/pages/menu/profile/userInfo"),
              beforeEnter: (to, from, next) => {
                window.scrollTo({ behavior: "smooth", top: 200, left: 0 });
                next();
              },
            },
            {
              path: "settings",
              name: "menu.profile.setting",
              meta: { main_page: true },
              component: () =>
                import("./view/pages/menu/profile/profileSetting"),
              beforeEnter: (to, from, next) => {
                window.scrollTo({ behavior: "smooth", top: 200, left: 0 });
                next();
              },
            },
            {
              path: "orders",
              name: "menu.profile.orders",
              meta: { main_page: true },
              component: () =>
                import("./view/pages/menu/profile/profileOrders"),
              beforeEnter: (to, from, next) => {
                window.scrollTo({ behavior: "smooth", top: 200, left: 0 });
                next();
              },
            },
            {
              path: "addresses",
              name: "menu.profile.addresses",
              meta: { main_page: true },
              component: () =>
                import("./view/pages/menu/profile/profileAddresses"),
              beforeEnter: (to, from, next) => {
                window.scrollTo({ behavior: "smooth", top: 200, left: 0 });
                next();
              },
            },
          ],
        },
        {
          path: "/qr/monitoring",
          name: "qr.monitoring",
          props: true,
          component: () => import("./view/pages/list/qrMonitoring"),
          meta: {
            title: "ROUTE.TITLES.QR_MONITORING",
            has_ribbon: true,
            permission: "adminQrMonitoring_access",
          },
        },
        {
          path: "/qr/list",
          name: "qr.list",
          props: true,
          component: () => import("./view/pages/list/qrList"),
          meta: { title: "ROUTE.TITLES.QR_LIST", has_ribbon: true },
        },
        {
          path: "/qr/list/commercial/:name",
          name: "qr.name.list",
          props: true,
          component: () =>
            import("./view/components/commercial/partnership.vue"),
          meta: { title: "ROUTE.TITLES.QR_NAME_LIST", has_ribbon: true },
          children: [
            {
              path: ":id",
              name: "qr.name.id.commercial",
              props: true,
              component: () =>
                import("./view/components/commercial/partnership.vue"),
              meta: { title: "ROUTE.TITLES.QR_NAME_LIST", has_ribbon: true },
            },
          ],
        },
        {
          path: "/qr/generate/multiple",
          name: "qr.generate.multiple",
          props: true,
          component: () =>
            import("./view/pages/generate/generateMultipleQrCode.vue"),
          meta: {
            title: "ROUTE.TITLES.QR_GENERATE_MULTIPLE",
            has_ribbon: true,
            permission: "qr_multiple_generate",
          },
        },
         {
          path: "qr/bulk",
          name: "QrsBulk",
          component: () =>
            import("./view/pages/generate/generateMultipleQr.vue"),
          meta: {
            title: "ساخت گروهی کیوار کد",
            has_ribbon: true,
          },
        },
        {
          path: "/qr/cardVisit",
          name: "qr.cardVisit",
          props: true,
          component: () => import("./view/pages/qrland/cardVisit"),
          meta: { title: "ROUTE.TITLES.QR_CARD_VISIT", has_ribbon: true },
        },
         {
          path: "/qr/cardVisitPro",
          name: "qr.cardVisitPro",
          props: true,
          component: () => import("./view/pages/qrland/cardVisitPro"),
          meta: { title: "ROUTE.TITLES.QR_CARD_VISIT_PRO", has_ribbon: true },
        },
        {
          path: "HelpInfo",
          name: "HelpInfo",
          props: true,
          component: () =>
            import(
              "./view/pages/qrland/components/helpAcordion/test_help_info"
            ),
          meta: { title: "ROUTE.TITLES.HELP_INFO", has_ribbon: true },
        },
        {
          path: "/qr/menu",
          name: "qr.menu",
          props: true,
          component: () => import("./view/pages/otherQrTypes/menu/create"),
          meta: { title: "ROUTE.TITLES.QR_MENU", has_ribbon: true },
        },
        {
          path: "/qr/appointment",
          name: "qr.appointment",
          props: true,
          component: () =>
            import(
              "./view/pages/otherQrTypes/appointment/createAppointment.vue"
            ),
          meta: { title: "ROUTE.TITLES.QR_APPOINTMENT", has_ribbon: true },
        },
        {
          path: "/qr/insurance",
          name: "qr.insurance",
          props: true,
          component: () =>
            import("./view/pages/otherQrTypes/insurance/createInsurance.vue"),
          meta: { title: "ROUTE.TITLES.QR_INSURANCE", has_ribbon: true },
        },
        {
          path: "/qr/bPage",
          name: "qr.bPage",
          props: true,
          component: () =>
            import("./view/pages/businessPage/pages/createBpage"),
          meta: { title: "ROUTE.TITLES.QR_BPAGE", has_ribbon: true },
        },
        {
          path: "/qr/cPage",
          name: "qr.cPage",
          props: true,
          component: () => import("./view/pages/commercial/pages/createBpage"),
          meta: { title: "ROUTE.TITLES.QR_CPAGE", has_ribbon: true },
        },
        {
          path: "/qr/bShop",
          name: "qr.bShop",
          props: true,
          component: () =>
            import("./view/pages/businessPage/pages/shopPage/createShop"),
          meta: { title: "ROUTE.TITLES.QR_BSHOP", has_ribbon: true },
        },
        {
          path: "/digi",
          name: "qr.digi",
          props: true,
          component: () =>
            import("./view/pages/digi/ShowSetPrice"),
          meta: { title: "ROUTE.TITLES.DIGI", 
            permission: "digikala_managment",
            has_ribbon: true },
        },
        {
          path: "/qr/editBShop/:name",
          name: "qr.name.editBShop",
          props: true,
          component: () =>
            import("./view/pages/businessPage/pages/shopPage/editShop"),
          meta: { title: "ROUTE.TITLES.QR_NAME_EDIT_BSHOP", has_ribbon: true },
          children: [
            {
              path: ":id",
              name: "qr.name.id.editBShop",
              props: true,
              component: () =>
                import("./view/pages/businessPage/pages/shopPage/editShop"),
              meta: {
                title: "ROUTE.TITLES.QR_NAME_EDIT_BSHOP",
                has_ribbon: true,
              },
            },
          ],
        },
        {
          path: "/qr/link/:name",
          name: "qrLinkEdit",
          props: true,
          component: () => import("./view/pages/qrland/qrLinkEdit.vue"),
          meta: { title: "ROUTE.TITLES.QR_LINK_EDIT", has_ribbon: true },
          children: [
            {
              path: ":id",
              name: "qrLinkEditid",
              props: true,
              component: () => import("./view/pages/qrland/qrLinkEdit.vue"),
              meta: { title: "ROUTE.TITLES.QR_LINK_EDIT", has_ribbon: true },
            },
          ],
        },
        {
          path: "/qr/linkpro/:name",
          name: "qrLinkEditpro",
          props: true,
          component: () => import("./view/pages/clickyarseo/clickyarseoEdit.vue"),
          meta: { title: "ROUTE.TITLES.QR_LINK_EDIT_PRO", has_ribbon: true },
          children: [
            {
              path: ":id",
              name: "qrLinkEditidpro",
              props: true,
              component: () => import("./view/pages/clickyarseo/clickyarseoEdit.vue"),
              meta: { title: "ROUTE.TITLES.QR_LINK_EDIT_PRO", has_ribbon: true },
            },
          ],
        },
        {
          path: "/qr/design2/:name",
          name: "qr.name.design2",
          component: () => import("./view/pages/qrland/designEdit"),
          meta: { title: "ROUTE.TITLES.QR_NAME_DESIGN", has_ribbon: true },
        },
        {
          path: "/qr/design/:name",
          name: "qr.name.design",
          component: () => import("./view/pages/qrland/designEdit"),
          meta: { title: "ROUTE.TITLES.QR_NAME_DESIGN", has_ribbon: true },
          children: [
            {
              path: ":id",
              name: "qr.name.id.design",
              component: () => import("./view/pages/qrland/designEdit"),
              meta: { title: "ROUTE.TITLES.QR_NAME_DESIGN", has_ribbon: true },
            },
          ],
        },
        {
          path: "/qr/setting2/:name",
          name: "qr.name.setting2",
          component: () => import("./view/pages/qrland/settingEdit"),
          meta: { title: "ROUTE.TITLES.QR_NAME_SETTING", has_ribbon: true },
        },
        {
          path: "/qr/setting/:name",
          name: "qr.name.setting",
          component: () => import("./view/pages/qrland/settingEdit"),
          meta: { title: "ROUTE.TITLES.QR_NAME_SETTING", has_ribbon: true },
          children: [
            {
              path: ":id",
              name: "qr.name.id.setting",
              component: () => import("./view/pages/qrland/settingEdit"),
              meta: { title: "ROUTE.TITLES.QR_NAME_SETTING", has_ribbon: true },
            },
          ],
        },
        {
          path: "/qr/edit/:name",
          name: "qr.name.edit",
          props: true,
          component: () => import("./view/pages/qrland/editVisit"),
          meta: { title: "ROUTE.TITLES.QR_NAME_EDIT", has_ribbon: true },
          children: [
            {
              path: ":id",
              name: "qr.name.id.edit",
              component: () => import("./view/pages/qrland/editVisit"),
              meta: { title: "ROUTE.TITLES.QR_NAME_EDIT", has_ribbon: true },
            },
          ],
        },
          {
          path: "/qr/editpro/:name",
          name: "qr.name.edit.pro",
          props: true,
          component: () => import("./view/pages/qrland/editVisitPro"),
          meta: { title: "ROUTE.TITLES.QR_NAME_EDIT_PRO", has_ribbon: true },
          children: [
            {
              path: ":id",
              name: "qr.name.id.edit.pro",
              component: () => import("./view/pages/qrland/editVisitPro"),
              meta: { title: "ROUTE.TITLES.QR_NAME_EDIT_PRO", has_ribbon: true },
            },
          ],
        },
        {
          path: "/qr/editBPage/:name",
          name: "qr.name.editBPage",
          props: true,
          component: () => import("./view/pages/businessPage/pages/editBpage"),
          meta: { title: "ROUTE.TITLES.QR_NAME_EDIT_BPAGE", has_ribbon: true },
          children: [
            {
              path: ":id",
              name: "qr.name.id.editBpage",
              props: true,
              component: () =>
                import("./view/pages/businessPage/pages/editBpage"),
              meta: {
                title: "ROUTE.TITLES.QR_NAME_EDIT_BPAGE",
                has_ribbon: true,
              },
            },
          ],
        },
        {
          path: "/qr/editCPage/:name",
          name: "qr.editCPage",
          props: true,
          component: () => import("./view/pages/commercial/pages/editBpage"),
          meta: { title: "ROUTE.TITLES.QR_EDIT_CPAGE", has_ribbon: true },
          children: [
            {
              path: ":id",
              name: "qr.editCPage.id",
              props: true,
              component: () =>
                import("./view/pages/businessPage/pages/editBpage"),
              meta: {
                title: "ROUTE.TITLES.QR_NAME_EDIT_BPAGE",
                has_ribbon: true,
              },
            },
          ],
        },
        {
          path: "/qr/insurance/:name",
          name: "qr.name.insurance",
          props: true,
          component: () =>
            import("./view/pages/otherQrTypes/insurance/editInsurance.vue"),
          meta: { title: "ROUTE.TITLES.QR_NAME_INSURANCE", has_ribbon: true },
          children: [
            {
              path: ":id",
              name: "qr.name.id.insurance",
              props: true,
              component: () =>
                import("./view/pages/otherQrTypes/insurance/editInsurance.vue"),
              meta: {
                title: "ROUTE.TITLES.QR_NAME_INSURANCE",
                has_ribbon: true,
              },
            },
          ],
        },
        {
          path: "/qr/editMenu/:name",
          name: "qr.name.editMenu",
          props: true,
          component: () => import("./view/pages/otherQrTypes/menu/editMenu"),
          meta: { title: "ROUTE.TITLES.QR_NAME_EDIT_MENU", has_ribbon: true },
          children: [
            {
              path: ":id",
              name: "qr.name.id.editMenu",
              props: true,
              component: () =>
                import("./view/pages/otherQrTypes/menu/editMenu"),
              meta: {
                title: "ROUTE.TITLES.QR_NAME_EDIT_MENU",
                has_ribbon: true,
              },
            },
          ],
        },
        {
          path: "/qr/editApplication/:name",
          name: "qr.name.editApplication",
          props: true,
          component: () =>
            import("./view/pages/otherQrTypes/applicaion/editApplication.vue"),
          meta: {
            title: "ROUTE.TITLES.QR_NAME_EDIT_APPLICATION",
            has_ribbon: true,
          },
          children: [
            {
              path: ":id",
              name: "qr.name.id.editApplication",
              props: true,
              component: () => import("./view/pages/voicePro/editVoicePro.vue"),
              meta: {
                title: "ROUTE.TITLES.QR_NAME_EDIT_APPLICATION",
                has_ribbon: true,
              },
            },
          ],
        },
        {
          path: "/qr/editAppointment/:name",
          name: "qr.name.editAppointment",
          props: true,
          component: () =>
            import("./view/pages/otherQrTypes/appointment/editAppointment.vue"),
          meta: {
            title: "ROUTE.TITLES.QR_NAME_EDIT_APPOINTMENT",
            has_ribbon: true,
          },
          children: [
            {
              path: ":id",
              name: "qr.name.id.editAppointment",
              props: true,
              component: () =>
                import(
                  "./view/pages/otherQrTypes/appointment/editAppointment.vue"
                ),
              meta: {
                title: "ROUTE.TITLES.QR_NAME_EDIT_APPOINTMENT",
                has_ribbon: true,
              },
            },
          ],
        },
        {
          path: "/qr/editPhoto/:name",
          name: "qr.name.editPhoto",
          component: () =>
            import("./view/pages/otherQrTypes/photoGallery/editPhoto"),
          meta: { title: "ROUTE.TITLES.QR_NAME_EDIT_PHOTO", has_ribbon: true },
          children: [
            {
              path: ":id",
              name: "qr.name.id.editPhoto",
              component: () =>
                import("./view/pages/otherQrTypes/photoGallery/editPhoto"),
              meta: {
                title: "ROUTE.TITLES.QR_NAME_EDIT_PHOTO",
                has_ribbon: true,
              },
            },
          ],
        },
        {
          path: "/qr/editcatalog/:name",
          name: "qr.name.editCatalog",
          component: () =>
            import("./view/pages/otherQrTypes/leafletCatalog/editCatalog"),
          meta: {
            title: "ROUTE.TITLES.QR_NAME_EDIT_CATALOG",
            has_ribbon: true,
          },
          children: [
            {
              path: ":id",
              name: "qr.name.id.editCatalog",
              component: () =>
                import("./view/pages/otherQrTypes/leafletCatalog/editCatalog"),
              meta: {
                title: "ROUTE.TITLES.QR_NAME_EDIT_CATALOG",
                has_ribbon: true,
              },
            },
          ],
        },
        {
          path: "/qr/editPdf/:name",
          name: "qr.name.editPdf",
          component: () =>
            import("./view/pages/otherQrTypes/pdfGallery/editPdf"),
          meta: { title: "ROUTE.TITLES.QR_NAME_EDIT_PDF", has_ribbon: true },
          children: [
            {
              path: ":id",
              name: "qr.name.id.editPdf",
              component: () =>
                import("./view/pages/otherQrTypes/pdfGallery/editPdf"),
              meta: {
                title: "ROUTE.TITLES.QR_NAME_EDIT_PDF",
                has_ribbon: true,
              },
            },
          ],
        },
        {
          path: "/qr/editVideo/:name",
          name: "qr.name.editVideo",
          props: true,
          component: () =>
            import("./view/pages/otherQrTypes/videoGallery/editVideo"),
          meta: { title: "ROUTE.TITLES.QR_NAME_EDIT_VIDEO", has_ribbon: true },
          children: [
            {
              path: ":id",
              name: "qr.name.id.editVideo",
              props: true,
              component: () =>
                import("./view/pages/otherQrTypes/videoGallery/editVideo"),
              meta: {
                title: "ROUTE.TITLES.QR_NAME_EDIT_VIDEO",
                has_ribbon: true,
              },
            },
          ],
        },
        {
          path: "/qr/editVoice/:name",
          name: "qr.name.editVoice",
          props: true,
          component: () => import("./view/pages/Voice/editVoice.vue"),
          meta: { title: "ROUTE.TITLES.QR_NAME_EDIT_VOICE", has_ribbon: true },
          children: [
            {
              path: ":id",
              name: "qr.name.id.editVoice",
              props: true,
              component: () => import("./view/pages/Voice/editVoice.vue"),
              meta: {
                title: "ROUTE.TITLES.QR_NAME_EDIT_VOICE",
                has_ribbon: true,
              },
            },
          ],
        },
        {
          path: "/qr/editFeedback/:name",
          name: "qr.name.editFeedback",
          props: true,
          component: () =>
            import("./view/pages/otherQrTypes/feedBack/editFeedback.vue"),
          meta: {
            title: "ROUTE.TITLES.QR_NAME_EDIT_FEEDBACK",
            has_ribbon: true,
          },
          children: [
            {
              path: ":id",
              name: "qr.name.id.editFeedback",
              props: true,
              component: () =>
                import("./view/pages/otherQrTypes/feedBack/editFeedback.vue"),
              meta: {
                title: "ROUTE.TITLES.QR_NAME_EDIT_FEEDBACK",
                has_ribbon: true,
              },
            },
          ],
        },
        {
          path: "/qr/consultationQrEdit/:name",
          name: "qr.name.consultationQrEdit",
          props: true,
          component: () =>
            import(
              "./view/pages/otherQrTypes/consultationQr/consultationQrEdit.vue"
            ),
          meta: {
            title: "ROUTE.TITLES.QR_NAME_CONSULTATION_QR_EDIT",
            has_ribbon: true,
          },
          children: [
            {
              path: ":id",
              name: "qr.name.id.consultationQrEdit",
              props: true,
              component: () =>
                import(
                  "./view/pages/otherQrTypes/consultationQr/consultationQrEdit.vue"
                ),
              meta: {
                title: "ROUTE.TITLES.QR_NAME_CONSULTATION_QR_EDIT",
                has_ribbon: true,
              },
            },
          ],
        },
        {
          path: "/qr/editVoicePro/:name",
          name: "qr.name.editVoicePro",
          props: true,
          component: () => import("./view/pages/voicePro/editVoicePro.vue"),
          meta: {
            title: "ROUTE.TITLES.QR_NAME_EDIT_VOICE_PRO",
            has_ribbon: true,
          },
          children: [
            {
              path: ":id",
              name: "qr.name.id.editVoicePro",
              props: true,
              component: () => import("./view/pages/voicePro/editVoicePro.vue"),
              meta: {
                title: "ROUTE.TITLES.QR_NAME_EDIT_VOICE_PRO",
                has_ribbon: true,
              },
            },
          ],
        },
        {
          path: "/qr/editText/:name",
          name: "qr.name.editText",
          props: true,
          component: () =>
            import("./view/pages/otherQrTypes/text/editText.vue"),
          meta: { title: "ROUTE.TITLES.QR_NAME_EDIT_TEXT", has_ribbon: true },
          children: [
            {
              path: ":id",
              name: "qr.name.id.editText",
              props: true,
              component: () =>
            import("./view/pages/otherQrTypes/text/editText.vue"),
              meta: {
                title: "ROUTE.TITLES.QR_NAME_EDIT_TEXT",
                has_ribbon: true,
              },
            },
          ],
        },
        {
          path: "/qr/editSocial/:name",
          name: "qr.name.editSocial",
          props: true,
          component: () =>
            import("./view/pages/otherQrTypes/socialMedia/editSocial"),
          meta: { title: "ROUTE.TITLES.QR_NAME_EDIT_SOCIAL", has_ribbon: true },
          children: [
            {
              path: ":id",
              name: "qr.name.id.editSocial",
              props: true,
              component: () =>
                import("./view/pages/otherQrTypes/socialMedia/editSocial"),
              meta: {
                title: "ROUTE.TITLES.QR_NAME_EDIT_SOCIAL",
                has_ribbon: true,
              },
            },
          ],
        },
        {
          path: "/qr/editEitaa/:name",
          name: "qr.name.editEitaa",
          props: true,
          component: () =>
            import("./view/pages/otherQrTypes/eitaa/editEitaa.vue"),
          meta: { title: "ویرایش کیوآر ایتا", has_ribbon: true },
          children: [
            {
              path: ":id",
              name: "qr.name.id.editEitaa",
              props: true,
              component: () =>
                import("./view/pages/otherQrTypes/eitaa/editEitaa.vue"),
              meta: {
                title: "ویرایش کیوآر ایتا",
                has_ribbon: true,
              },
            },
          ],
        },
          {
          path: "/qr/editRobika/:name",
          name: "qr.name.editRobika",
          props: true,
          component: () =>
            import("./view/pages/otherQrTypes/robika/editRobika.vue"),
          meta: { title: "ویرایش کیوآر ایتا", has_ribbon: true },
          children: [
            {
              path: ":id",
              name: "qr.name.id.editRobika",
              props: true,
              component: () =>
                import("./view/pages/otherQrTypes/robika/editRobika.vue"),
              meta: {
                title: "ویرایش کیوآر روبیکا",
                has_ribbon: true,
              },
            },
          ],
        },

        {
          path: "/qr/editBale/:name",
          name: "qr.name.editBale",
          props: true,
          component: () =>
            import("./view/pages/otherQrTypes/bale/editBale.vue"),
          meta: { title: "ویرایش کیوآر بله", has_ribbon: true },
          children: [
            {
              path: ":id",
              name: "qr.name.id.editBale",
              props: true,
              component: () =>
                import("./view/pages/otherQrTypes/bale/editBale.vue"),
              meta: {
                title: "ویرایش کیوآر بله",
                has_ribbon: true,
              },
            },
          ],
        },
        {
          path: "/qr/statistics2/:name",
          name: "qr.name.statistics2",
          props: true,
          component: () => import("./view/pages/list/statics"),
          meta: { title: "ROUTE.TITLES.QR_NAME_STATISTICS", has_ribbon: true },
        },
        {
          path: "/qr/statistics/:name",
          name: "qr.name.statistics",
          props: true,
          component: () => import("./view/pages/list/statics"),
          meta: { title: "ROUTE.TITLES.QR_NAME_STATISTICS", has_ribbon: true },
          children: [
            {
              path: ":id",
              name: "qr.name.id.statistics",
              props: true,
              component: () => import("./view/pages/list/statics"),
              meta: {
                title: "ROUTE.TITLES.QR_NAME_STATISTICS",
                has_ribbon: true,
              },
            },
          ],
        },
        {
          path: "/qr/cate",
          name: "qr.cat",
          props: true,
          redirect: "/qr/cate/share",
          component: () => import("./view/pages/qrland/category.vue"),
          meta: { title: "ROUTE.TITLES.QR_CATE", has_ribbon: true },
          children: [
            {
              path: "share",
              name: "qr.share",
              props: true,
              component: () =>
                import("./view/pages/qrland/categories/catShare.vue"),
              meta: { title: "ROUTE.TITLES.QR_SHARE", has_ribbon: true },
            },
            {
              path: "business-shop",
              name: "qr.business-shop",
              props: true,
              component: () =>
                import("./view/pages/qrland/categories/catBusinessShop"),
              meta: {
                title: "ROUTE.TITLES.QR_BUSINESS_SHOP",
                has_ribbon: true,
              },
            },
            {
              path: "co-organ",
              name: "qr.co-organ",
              props: true,
              component: () =>
                import("./view/pages/qrland/categories/catCoOrgan"),
              meta: { title: "ROUTE.TITLES.QR_CO_ORGAN", has_ribbon: true },
            },
            {
              path: "contact",
              name: "qr.contact",
              props: true,
              component: () =>
                import("./view/pages/qrland/categories/catContact"),
              meta: { title: "ROUTE.TITLES.QR_CONTACT", has_ribbon: true },
            },
            {
              path: "notices",
              name: "qr.notices",
              props: true,
              component: () =>
                import("./view/pages/qrland/categories/catNotices"),
              meta: { title: "ROUTE.TITLES.QR_NOTICES", has_ribbon: true },
            },
            {
              path: "others",
              name: "qr.others",
              props: true,
              component: () =>
                import("./view/pages/qrland/categories/catOthers"),
              meta: { title: "ROUTE.TITLES.QR_OTHERS", has_ribbon: true },
            },
            {
              path: "statics",
              name: "qr.statics",
              props: true,
              component: () =>
                import("./view/pages/qrland/categories/catStatics"),
              meta: { title: "ROUTE.TITLES.QR_STATICS", has_ribbon: true },
            },
            {
              path: "dynamics",
              name: "qr.dynamics",
              props: true,
              component: () =>
                import("./view/pages/qrland/categories/catDynamics"),
              meta: { title: "ROUTE.TITLES.QR_DYNAMICS", has_ribbon: true },
            },
            {
              path: "business",
              name: "qr.business",
              props: true,
              component: () =>
                import("./view/pages/qrland/categories/catDBusiness"),
              meta: { title: "ROUTE.TITLES.QR_D_BUSINESS", has_ribbon: true },
            },
            {
              path: "organs",
              name: "qr.organs",
              props: true,
              component: () => import("./view/pages/qrland/category.vue"),
              meta: { title: "ROUTE.TITLES.QR_D_ORGANS", has_ribbon: true },
            },
            {
              path: "government",
              name: "qr.government",
              props: true,
              component: () => import("./view/pages/qrland/category.vue"),
              meta: { title: "ROUTE.TITLES.QR_D_GOVERNMENT", has_ribbon: true },
            },
             {
              path: "socialnetwork",
              name: "qr.socialnetwork",
              props: true,
              component: () => import("./view/pages/qrland/categories/catSocialNetwork.vue"),
              meta: { title: "شبکه اجتماعی", has_ribbon: true },
            },
          ],
        },
        {
          path: "/qr/video",
          name: "qr.video",
          props: true,
          component: () =>
            import("./view/pages/otherQrTypes/videoGallery/videoGallery"),
          meta: { title: "ROUTE.TITLES.QR_VIDEO", has_ribbon: true },
        },
        {
          path: "/qr/application",
          name: "qr.application",
          props: true,
          component: () =>
            import(
              "./view/pages/otherQrTypes/applicaion/createApplication.vue"
            ),
          meta: { title: "ROUTE.TITLES.QR_APPLICATION", has_ribbon: true },
        },
        {
          path: "/qr/luckWheel",
          name: "qr.luckWheel",
          props: true,
          component: () =>
            import("./view/pages/otherQrTypes/luckWheel/createLuckWheel.vue"),
          meta: { title: "ROUTE.TITLES.QR_LUCK_WHEEL", has_ribbon: true },
        },
        {
          path: "/qr/luck-wheel/:name",
          name: "qr.name.luckWheel",
          props: true,
          component: () =>
            import("./view/pages/otherQrTypes/luckWheel/EditLuckWheel"),
          meta: { title: "ROUTE.TITLES.QR_LUCK_WHEEL_Edit", has_ribbon: true },
          children: [
            {
              path: ":id",
              name: "qr.name.id.luckWheel",
              props: true,
              component: () =>
                import("./view/pages/otherQrTypes/luckWheel/EditLuckWheel"),
              meta: {
                title: "ROUTE.TITLES.QR_LUCK_WHEEL_Edit",
                has_ribbon: true,
              },
            },
          ],
        },
        {
          path: "/qr/voice",
          name: "qr.voice",
          props: true,
          component: () => import("./view/pages/Voice/createVoice.vue"),
          meta: { title: "ROUTE.TITLES.QR_VOICE", has_ribbon: true },
        },
        {
          path: "/qr/voicePro",
          name: "qr.voicePro",
          props: true,
          component: () => import("./view/pages/voicePro/voiceGalleryPro.vue"),
          meta: { title: "ROUTE.TITLES.QR_VOICE_PRO", has_ribbon: true },
        },
        {
          path: "/qr/consultationQr",
          name: "qr.consultationQr",
          props: true,
          component: () =>
            import(
              "./view/pages/otherQrTypes/consultationQr/consultationQr.vue"
            ),
          meta: { title: "ROUTE.TITLES.QR_CONSULTATION_QR", has_ribbon: true },
        },
        {
          path: "/qr/feedback",
          name: "qr.feedback",
          props: true,
          component: () =>
            import("./view/pages/otherQrTypes/feedBack/createFeedback.vue"),
          meta: { title: "ROUTE.TITLES.QR_FEEDBACK", has_ribbon: true },
        },
        {
          path: "/qr/photo",
          name: "qr.photo",
          props: true,
          component: () =>
            import("./view/pages/otherQrTypes/photoGallery/photoGallery"),
          meta: { title: "ROUTE.TITLES.QR_PHOTO", has_ribbon: true },
        },
        {
          path: "/qr/gift",
          name: "qr.gift",
          props: true,
          component: () =>
            import("./view/pages/otherQrTypes/giftGallery/giftGallery.vue"),
          meta: { title: "ROUTE.TITLES.QR_GIFT", has_ribbon: true },
        },
         {
          path: "/qr/editgift/:name",
          name: "qr.name.editgift",
          component: () =>
            import("./view/pages/otherQrTypes/giftGallery/editGiftGallery.vue"),
          meta: { title: "ROUTE.TITLES.QR_NAME_EDIT_GIFT", has_ribbon: true },
          children: [
            {
              path: ":id",
              name: "qr.name.id.editgift",
              component: () =>
            import("./view/pages/otherQrTypes/giftGallery/editGiftGallery.vue"),
              meta: {
                title: "ROUTE.TITLES.QR_NAME_EDIT_GIFT",
                has_ribbon: true,
              },
            },
          ],
        },
        {
          path: "/qr/pdf",
          name: "qr.pdf",
          props: true,
          component: () =>
            import("./view/pages/otherQrTypes/pdfGallery/pdfGallery"),
          meta: { title: "ROUTE.TITLES.QR_PDF", has_ribbon: true },
        },
        {
          path: "/qr/catalog",
          name: "qr.catalog",
          props: true,
          component: () =>
            import("./view/pages/otherQrTypes/leafletCatalog/create"),
          meta: { title: "ROUTE.TITLES.QR_CATALOG", has_ribbon: true },
        },
        {
          path: "/qr/location",
          name: "qr.location",
          props: true,
          component: () => import("./view/pages/qrland/components/qrLocation"),
          meta: { title: "ROUTE.TITLES.QR_LOCATION", has_ribbon: true },
        },
        {
          path: "/qr/socialMedia",
          name: "qr.socialMedia",
          props: true,
          component: () =>
            import("./view/pages/otherQrTypes/socialMedia/indexSocial.vue"),
          meta: { title: "ROUTE.TITLES.QR_SOCIAL_MEDIA", has_ribbon: true },
        },
         {
          path: "/qr/bale",
          name: "qr.bale",
          props: true,
          component: () =>
            import("./view/pages/otherQrTypes/bale/indexBale.vue"),
          meta: { title: "شبکه اجتماعی بله", has_ribbon: true },
        },
        {
          path: "/qr/eitaa",
          name: "qr.eitaa",
          props: true,
          component: () =>
            import("./view/pages/otherQrTypes/eitaa/indexEitaa.vue"),
          meta: { title: "شبکه اجتماعی ایتا", has_ribbon: true },
        },
         {
          path: "/qr/robika",
          name: "qr.robika",
          props: true,
          component: () =>
            import("./view/pages/otherQrTypes/robika/indexRobika.vue"),
          meta: { title: "شبکه اجتماعی روبیکا", has_ribbon: true },
        },
        {
          path: "/qr/Qrtext",
          name: "qr.Qrtext",
          props: true,
          component: () =>
            import("./view/pages/otherQrTypes/text/indexText.vue"),
          meta: { title: "ROUTE.TITLES.QR_TEXT", has_ribbon: true },
        },
        {
          path: "/qr/link",
          name: "qr.link",
          props: true,
          component: () => import("./view/pages/qrland/qrLink"),
          meta: { title: "ROUTE.TITLES.QR_LINK", has_ribbon: true },
        },
         {
          path: "/qr/linkpro",
          name: "qr.linkPro",
          props: true,
          component: () => import("./view/pages/clickyarseo/clickyarseo"),
          meta: { title: "ROUTE.TITLES.QR_LINK_PRO", has_ribbon: true },
        },
        {
          path: "/qr/text",
          name: "qr.text",
          props: true,
          component: () => import("./view/pages/qrland/components/textQr"),
          meta: { title: "ROUTE.TITLES.QR_TEXT", has_ribbon: true },
        },
        {
          path: "/qr/card",
          name: "qr.card",
          props: true,
          component: () => import("./view/pages/multiCart/multiCard.vue"),
          // meta: {title: "ROUTE.TITLES.QR_LINK", has_ribbon: true},
          meta: {
            title: "ROUTE.TITLES.QR_MULTICART",
            has_ribbon: true,
          },
        },
         {
          path: "/qr/bankcards",
          name: "qr.bankcards",
          props: true,
          component: () => import("./view/pages/BankCart/BankCard.vue"),
          // meta: {title: "ROUTE.TITLES.QR_LINK", has_ribbon: true},
          meta: {
            title: "ساخت کیوار کیوکارت",
            has_ribbon: true,
          },
        },
        {
          path: "/qr/mail",
          name: "qr.mail",
          props: true,
          component: () => import("./view/pages/qrland/qrMail"),
          meta: { title: "ROUTE.TITLES.QR_MAIL", has_ribbon: true },
        },
        {
          path: "/qr/call",
          name: "qr.call",
          props: true,
          component: () => import("./view/pages/qrland/components/qrCall"),
          meta: { title: "ROUTE.TITLES.QR_CALL", has_ribbon: true },
        },
        {
          path: "/qr/sms",
          name: "qr.sms",
          props: true,
          component: () => import("./view/pages/qrland/qrSms"),
          meta: { title: "ROUTE.TITLES.QR_SMS", has_ribbon: true },
        },
        {
          path: "/qr/whatsApp",
          name: "qr.whatsApp",
          props: true,
          component: () => import("./view/pages/qrland/qrwhatsApp"),
          meta: { title: "ROUTE.TITLES.QR_WHATSAPP", has_ribbon: true },
        },
        {
          path: "/qr/site",
          name: "qr.site",
          props: true,
          component: () => import("./view/pages/qrland/components/qrSite"),
          meta: { title: "ROUTE.TITLES.QR_SITE", has_ribbon: true },
        },
        {
          path: "/qr/instagram",
          name: "qr.instagram",
          props: true,
          component: () => import("./view/pages/qrland/components/qrInstagram"),
          meta: { title: "ROUTE.TITLES.QR_INSTAGRAM", has_ribbon: true },
        },
        {
          path: "/qr/skype",
          name: "qr.skype",
          props: true,
          component: () => import("./view/pages/qrland/components/qrSkype"),
          meta: { title: "ROUTE.TITLES.QR_SKYPE", has_ribbon: true },
        },
        {
          path: "/qr/wifi",
          name: "qr.wifi",
          props: true,
          component: () => import("./view/pages/qrland/components/qrWifi"),
          meta: { title: "ROUTE.TITLES.QR_WIFI", has_ribbon: true },
        },
        {
          path: "/qr/business",
          name: "qr.business.page",
          props: true,
          component: () => import("./view/pages/Business"),
          meta: { title: "ROUTE.TITLES.QR_BUSINESS", has_ribbon: true },
        },
        {
          path: "/qr/discount",
          name: "qr.discount",
          props: true,
          component: () => import("./view/pages/discount"),
          meta: { title: "ROUTE.TITLES.QR_DISCOUNT", has_ribbon: true },
        },
        {
          path: "/qr/product/shop",
          name: "qr.product.shop",
          props: true,
          component: () => import("./view/pages/product/productCard"),
          meta: { title: "ROUTE.TITLES.QR_PRODUCT_SHOP", has_ribbon: true },
        },
        {
          path: "/qr/product/productPro",
          name: "qr.product.productPro",
          props: true,
          component: () => import("./view/pages/productPro/productPro.vue"),
          meta: { title: "ROUTE.TITLES.QR_PRODUCTPRO", has_ribbon: true },
        },
        {
          path: "/qr/produc/label",
          name: "qr.product.label",
          props: true,
          component: () =>
            import("./view/pages/productLabel/createProductLabel"),
          meta: { title: "ROUTE.TITLES.QR_PRODUCT_LABEL", has_ribbon: true },
        },
         {
          path: "/qr/price/label",
          name: "qr.price.label",
          props: true,
          component: () =>
            import("./view/pages/priceLabel/createPriceLabel.vue"),
          meta: { title: "لیبل قیمت", has_ribbon: true },
        },
        {
          path: "/qr/goldlabel",
          name: "qr.gold.label",
          props: true,
          component: () => import("./view/pages/goldLabel/createGoldLabel"),
          meta: { title: "ROUTE.TITLES.QR_GOLD_LABEL", has_ribbon: true },
        },
        {
          path: "qr/product/template",
          name: "qr.product.template",
          component: () => import("./view/components/Template/Product"),
          meta: { title: "ROUTE.TITLES.QR_PRODUCT_TEMPLATE", has_ribbon: true },
        },
        {
          path: "admin/category",
          name: "qr.product.category",
          component: () => import("./view/components/Category/categoryList"),
          meta: { title: "ROUTE.TITLES.ADMIN_CATEGORY", has_ribbon: true },
        },
        {
          path: "admin/nfc-orders",
          name: "qr.nfc.orders",
          component: () =>
            import("./view/pages/admin/nfcOrders/ordersList.vue"),
          meta: {
            title: "ROUTE.TITLES.QR_NFC_ORDERS",
            has_ribbon: true,
            permission: "adminQrMonitoring_access",
          },
        },
        {
          path: "/qr/product/:name",
          name: "qr.name.product",
          props: true,
          component: () => import("./view/pages/product/editProduct"),
          meta: { title: "ROUTE.TITLES.QR_NAME_PRODUCT", has_ribbon: true },
          children: [
            {
              path: ":id",
              name: "qr.name.id.product",
              props: true,
              component: () => import("./view/pages/product/editProduct"),
              meta: { title: "ROUTE.TITLES.QR_NAME_PRODUCT", has_ribbon: true },
            },
          ],
        },
        {
          path: "/qr/productPro/:name",
          name: "qr.name.productPro",
          props: true,
          component: () => import("./view/pages/productPro/editProductPro"),
          meta: { title: "ROUTE.TITLES.QR_NAME_PRODUCTPRO", has_ribbon: true },
          children: [
            {
              path: ":id",
              name: "qr.name.id.productPro",
              props: true,
              component: () => import("./view/pages/productPro/editProductPro"),
              meta: {
                title: "ROUTE.TITLES.QR_NAME_PRODUCTPRO",
                has_ribbon: true,
              },
            },
          ],
        },
        {
          path: "/qr/multicard/:name",
          name: "qr.name.multicard",
          props: true,
          component: () => import("./view/pages/multiCart/editMultiCard.vue"),
          meta: {
            title: "ROUTE.TITLES.QR_MULTICART_EDIT",
            has_ribbon: true,
          },
          children: [
            {
              path: ":id",
              name: "qr.name.id.multicard",
              props: true,
              component: () =>
                import("./view/pages/multiCart/editMultiCard.vue"),
              meta: {
                title: "ROUTE.TITLES.QR_MULTICART_EDIT",
                has_ribbon: true,
              },
            },
          ],
        },
          {
          path: "/qr/bankcard/:name",
          name: "qr.name.bankCard",
          props: true,
          component: () => import("./view/pages/BankCart/editBankCard.vue"),
          meta: {
            title: "ROUTE.TITLES.QR_MULTICART_EDIT",
            has_ribbon: true,
          },
          children: [
            {
              path: ":id",
              name: "qr.name.id.bankCard",
              props: true,
              component: () =>
                import("./view/pages/BankCart/editBankCard.vue"),
              meta: {
                title: "ویرایش کیوکارت",
                has_ribbon: true,
              },
            },
          ],
        },
        {
          path: "/qr/labelproduct/:name",
          name: "qr.name.labelproduct",
          props: true,
          component: () => import("./view/pages/productLabel/editProductLabel"),
          meta: {
            title: "ROUTE.TITLES.QR_NAME_LABELPRODUCT",
            has_ribbon: true,
          },
          children: [
            {
              path: ":id",
              name: "qr.name.labelproduct.id",
              props: true,
              component: () =>
                import("./view/pages/productLabel/editProductLabel"),
              meta: {
                title: "ROUTE.TITLES.QR_NAME_LABELPRODUCT",
                has_ribbon: true,
              },
            },
          ],
        },
        {
          path: "/qr/labelprice/:name",
          name: "qr.name.labelprice",
          props: true,
          component: () => import("./view/pages/priceLabel/editPriceLabel.vue"),
          meta: {
            title: "ویرایش لیبل قیمت",
            has_ribbon: true,
          },
          children: [
            {
              path: ":id",
              name: "qr.name.labelprice.id",
              props: true,
              component: () =>
                import("./view/pages/priceLabel/editPriceLabel.vue"),
              meta: {
                title: "ویرایش لیبل قیمت",
                has_ribbon: true,
              },
            },
          ],
        },
        {
          path: "/qr/goldlabel/:name",
          name: "qr.name.goldproduct",
          props: true,
          component: () => import("./view/pages/goldLabel/editGoldLabel"),
          meta: { title: "ROUTE.TITLES.QR_NAME_GOLDPRODUCT", has_ribbon: true },
          children: [
            {
              path: ":id",
              name: "qr.name.goldproduct.id",
              props: true,
              component: () => import("./view/pages/goldLabel/editGoldLabel"),
              meta: {
                title: "ROUTE.TITLES.QR_NAME_GOLDPRODUCT",
                has_ribbon: true,
              },
            },
          ],
        },
        {
          path: "/qr/coins",
          name: "qr.coins",
          props: true,
          component: () => import("./view/pages/qrland/coins"),
          meta: { title: "ROUTE.TITLES.QR_COINS", has_ribbon: true },
        },
        {
          path: "/qr/shop",
          name: "qr.shop",
          props: true,
          component: () => import("./view/pages/shopAdminPanel/index"),
          meta: { title: "ROUTE.TITLES.QR_SHOP", has_ribbon: true },
        },
        {
          path: "/qr/twitter",
          name: "qr.twitter",
          props: true,
          component: () => import("./view/pages/qrland/components/twitter"),
          meta: { title: "ROUTE.TITLES.QR_TWITTER", has_ribbon: true },
        },
        {
          path: "uploader",
          name: "uploadCenter",
          component: () => import("./view/components/UploadCenter/Uploader"),
          meta: { title: "ROUTE.TITLES.UPLOAD_CENTER", has_ribbon: true },
        },
        {
          path: "pricing",
          name: "pricing",
          component: () => import("./view/pages/pricing/Index"),
          meta: { title: "ROUTE.TITLES.PRICING", has_ribbon: true, },
        },
        {
          path: "/qr/editattendance/:name",
          name: "qr.name.editattendance",
          props: true,
          component: () =>
            import("./view/pages/otherQrTypes/attendanceQr/attendanceQrEdit.vue"),
          meta: { title: "ROUTE.TITLES.editattendance", has_ribbon: true,           
             permission: "qrAdmin_access",
 },
          children: [
            {
              path: ":id",
              name: "qr.name.id.editattendance",
              props: true,
              component: () =>
                import("./view/pages/otherQrTypes/attendanceQr/attendanceQrEdit.vue"),
              meta: {
                title: "ROUTE.TITLES.editattendance",
                has_ribbon: true,
                permission: "qrAdmin_access",
              },
            },
          ],
        },
        {
          path: "qr/attendance",
          name: "qr.attendance",
          component: () => import("./view/pages/otherQrTypes/attendanceQr/attendanceQr.vue"),
          meta: { title: "ROUTE.TITLES.attendance", has_ribbon: true,
            permission: "qrAdmin_access",
           },
        },
        {
          path: "/qr/create/models",
          name: "qr.create.models",
          props: true,
          component: () => import("./view/pages/robot/createModel"),
          meta: { title: "ROUTE.TITLES.QR_CREATE_MODELS", has_ribbon: true },
        },
        {
          path: "/qr/create/memoriesModel",
          name: "qr.create.memories",
          props: true,
          component: () => import("./view/pages/robot/giftGallery/giftGalleryModel.vue"),
          meta: { title: "ROUTE.TITLES.CREATE_MEMORIES_MODEL", has_ribbon: true },
        },
         {
          path: "/qr/create/cardVisitProModel",
          name: "qr.create.cardVisitProModel",
          props: true,
          component: () => import("./view/pages/robot/cardVisitProModel.vue"),
          meta: { title: "ROUTE.TITLES.CREATE_CARD_VISIT_PRO_MODEL", has_ribbon: true },
        },
          {
          path: "/qr/create/productProModel",
          name: "qr.create.productProModel",
          props: true,
          component: () => import("./view/pages/robot/productProModel.vue"),
          meta: { title: "ROUTE.TITLES.CREATE_PRODUCT_PRO_MODEL", has_ribbon: true },
        },
        {
          path: "/qr/create/ProductLabelModel",
          name: "qr.create.ProductLabelModel",
          props: true,
          component: () => import("./view/pages/robot/createProductLabelModel.vue"),
          meta: { title: "ROUTE.TITLES.CREATE_PRODUCT_LABEL_MODEL", has_ribbon: true },
        },
        {
          path: "/qr/create/photoGalleryModel",
          name: "qr.create.photoGalleryModel",
          props: true,
          component: () => import("./view/pages/robot/photoGalleryModel.vue"),
          meta: { title: "ROUTE.TITLES.CREATE_PHOTO_GALLERY_MODEL", has_ribbon: true },
        },
         {
          path: "/qr/create/pdfGalleryModel",
          name: "qr.create.pdfGalleryModel",
          props: true,
          component: () => import("./view/pages/robot/pdfGalleryModel.vue"),
          meta: { title: "ROUTE.TITLES.CREATE_PDF_GALLERY_MODEL", has_ribbon: true },
        },
         {
          path: "/qr/create/SocialMediaModel",
          name: "qr.create.SocialMediaModel",
          props: true,
          component: () => import("./view/pages/robot/indexSocialModel.vue"),
          meta: { title:  "ROUTE.TITLES.CREATE_SOCIAL_MEDIA_MODEL", has_ribbon: true },
        },
        {
          path: "/qr/create/business",
          name: "qr.create.business",
          props: true,
          component: () => import("./view/pages/robot/createSimpleBModel"),
          meta: {
            title: "ROUTE.TITLES.QR_CREATE_BUSINESS_MODELS",
            has_ribbon: true,
          },
        },
        {
          path: "/qr/create/productModel",
          name: "qr.create.productModel",
          props: true,
          component: () => import("./view/pages/robot/createProductModel"),
          meta: {
            title: "ROUTE.TITLES.QR_CREATE_PRODUCT_MODEL",
            has_ribbon: true,
          },
        },
        {
          path: "/modelsList/:id/business",
          name: "qr.create.business.id",
          props: true,
          component: () => import("./view/pages/robot/form/editSimplePage.vue"),
          meta: {
            title: "ROUTE.TITLES.QR_CREATE_BUSINESS_MODELS",
            has_ribbon: true,
          },
        },
        {
          path: "/modelsList/:id/productCard",
          name: "qr.create.productCard",
          props: true,
          component: () => import("./view/pages/robot/editProductModel"),
          meta: {
            title: "ROUTE.TITLES.QR_CREATE_PRODUCT_MODEL",
            has_ribbon: true,
          },
        },
        {
          path: "/modelsList/:id/editVisitPro",
          name: "qr.create.visitcardpro",
          props: true,
          component: () => import("./view/pages/robot/editVisitProModel.vue"),
          meta: {
            title: "ROUTE.TITLES.EDIT_CARD_VISIT_PRO_MODEL",
            has_ribbon: true,
          },
        },
        {
          path: "/modelsList/:id/productPro",
          name: "qr.create.productPro",
          props: true,
          component: () => import("./view/pages/robot/editproductProModel.vue"),
          meta: {
            title: "ROUTE.TITLES.EDIT_PRODUCT_PRO_MODEL",
            has_ribbon: true,
          },
        },
          {
          path: "/modelsList/:id/productlabel",
          name: "ROUTE.TITLES.EDIT_CARD_VISIT_PRO_MODEL",
          props: true,
          component: () => import("./view/pages/robot/editProductLabelModel.vue"),
          meta: {
            title: "ROUTE.TITLES.EDIT_PRODUCT_LABEL_MODEL",
            has_ribbon: true,
          },
        },
        {
          path: "/modelsList/:id/photoGallery",
          name: "qr.create.photoGalleryedit",
          props: true,
          component: () => import("./view/pages/robot/editPhotoModel.vue"),
          meta: {
            title: "ROUTE.TITLES.EDIT_PHOTO_GALLERY_MODEL",
            has_ribbon: true,
          },
        },
        {
          path: "/modelsList/:id/pdfGallery",
          name: "qr.create.pdfGalleryedit",
          props: true,
          component: () => import("./view/pages/robot/editPdfModel.vue"),
          meta: {
            title: "ROUTE.TITLES.EDIT_PDF_GALLERY_MODEL",
            has_ribbon: true,
          },
        },
         {
          path: "/modelsList/:id/editSocialModel",
          name: "qr.create.editSocialModel",
          props: true,
          component: () => import("./view/pages/robot/editSocialModel.vue"),
          meta: {
            title: "ROUTE.TITLES.EDIT_SOCIAL_MEDIA_MODEL",
            has_ribbon: true,
          },
        },
        {
          path: "/qr/createModel/menu",
          name: "qr.create.menuModels",
          props: true,
          component: () => import("./view/pages/robot/createMenuModel"),
          meta: {
            title: "ROUTE.TITLES.QR_CREATE_MENU_MODELS",
            has_ribbon: true,
          },
        },
        {
          path: "/qr/create/shopPage",
          name: "qr.create.shopModel",
          props: true,
          component: () => import("./view/pages/robot/createBModel"),
          meta: {
            title: "ROUTE.TITLES.QR_CREATE_SHOP_MODEL",
            has_ribbon: true,
          },
        },
        {
          path: "modelsList",
          name: "modelsList",
          component: () => import("./view/pages/robot/modelsList"),
          meta: {
            title: "ROUTE.TITLES.MODELS_LIST",
            has_ribbon: true,
            permission: "models_list",
          },
        },
        {
          path: "modelsList/:id/edit",
          name: "modelsList.edit",
          props: true,
          component: () => import("./view/pages/robot/editModel"),
          meta: {
            title: "ROUTE.TITLES.MODELS_LIST_EDIT",
            has_ribbon: true,
            permission: "models_list",
          },
        },
        {
          path: "modelsList/:id/editMenu",
          name: "modelsList.menu.edit",
          props: true,
          component: () => import("./view/pages/robot/editMenuModel"),
          meta: {
            title: "ROUTE.TITLES.MODELS_LIST_MENU_EDIT",
            has_ribbon: true,
            permission: "models_list",
          },
        },
          {
          path: "modelsList/:id/editmemories",
          name: "modelsList.memories.edit",
          props: true,
          component: () => import("./view/pages/robot/giftGallery/editGiftGalleryModel.vue"),
          meta: {
            title: "ویرایش مدل قاب خاطره",
            has_ribbon: true,
            permission: "models_list",
          },
        },
        {
          path: "modelsList/:id/editBShop",
          name: "modelsList.Bmodel.edit",
          props: true,
          component: () => import("./view/pages/editBShopModel"),
          meta: {
            title: "ROUTE.TITLES.MODELS_LIST_BMODEL_EDIT",
            has_ribbon: true,
            permission: "models_list",
          },
        },
        {
          path: "/nfc",
          name: "nfc",
          component: () => import("./view/pages/nfc/index.vue"),
          meta: {
            title: "ROUTE.TITLES.NFC",
            has_ribbon: true,
            permission: "models_list",
          },
        },
        {
          path: "submitForm",
          name: "submitForm",
          component: () => import("./view/pages/robot/form/submitForm"),
          meta: {
            title: "ROUTE.TITLES.SUBMIT_FORM",
            has_ribbon: true,
            permission: "submit_Form",
          },
        },
        {
          path: "requestList",
          name: "requestList",
          component: () => import("./view/pages/robot/form/requestList"),
          meta: {
            title: "ROUTE.TITLES.REQUEST_LIST",
            has_ribbon: true,
            permission: "request_List",
          },
        },
        {
          path: "pureData",
          name: "pureData",
          component: () => import("./view/pages/robot/pureDataList"),
          meta: {
            title: "ROUTE.TITLES.PURE_DATA",
            has_ribbon: true,
            permission: "puredata_list",
          },
        },
        {
          path: "auto/create",
          name: "auto.create",
          component: () => import("./view/pages/robot/autoCard/create"),
          meta: { title: "ROUTE.TITLES.AUTO_CREATE", has_ribbon: true },
        },
        {
          path: "qr/create",
          name: "qr.create",
          component: () => import("./view/pages/robot/autoCard/createAuto"),
          meta: { title: "ROUTE.TITLES.QR_CREATE", has_ribbon: true },
        },
        {
          path: "history/reminder",
          name: "history.reminder",
          component: () =>
            import("./view/pages/list/history/reminder/reminderList"),
          meta: { title: "ROUTE.TITLES.HISTORY_REMINDER", has_ribbon: true },
        },
        {
          path: "history/reminder/user",
          name: "history.reminder.user",
          component: () =>
            import("./view/pages/list/history/reminder/reminderUser"),
          meta: { title: "ROUTE.TITLES.HISTORY_REMINDER", has_ribbon: true },
        },
        {
          path: "book",
          name: "book",
          component: () =>
            import(
              "./view/pages/otherQrTypes/leafletCatalog/components/turnViewer"
            ),
          meta: { title: "ROUTE.TITLES.BOOK", has_ribbon: true },
        },
        {
          name: "NfcList",
          path: "nfc/list",
          component: () => import("./view/pages/qr/nfc/list.vue"),
          meta: {
            title: "ROUTE.TITLES.NFC_LIST",
            has_ribbon: true,
            permission: "nfc_admin_list",
          },
        },
        {
          name: "ApiKeyManager",
          path: "qr/apikeymanager",
          component: () => import("./view/pages/GenTokenQr/ApiKeyManager.vue"),
          meta: {
            title: "ROUTE.TITLES.API_KEY_MANAGER",
            has_ribbon: true,
          },
        },
        {
          name: "PrePurchase",
          path: "qr/prepurchase",
          component: () => import("./view/pages/PrePurchase/PrePurchaseManager.vue"),
          meta: {
            title: "ROUTE.TITLES.PRE_PURCHASE",
            has_ribbon: true,
          },
        },  {
          name: "PrePurchase_model",
          path: "qr/PrePurchase_model",
          component: () => import("./view/pages/PrePurchase/PrePurchase_model.vue"),
          meta: {
            title: "ROUTE.TITLES.PRE_PURCHASE_MODEL",
            has_ribbon: true,
          },
        },
        
      ],
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      Vue.nextTick().then(() => {
        if (savedPosition) {
          resolve({ ...savedPosition, behavior: "smooth" });
        } else if (to.name === "qr.list") {
          resolve(false);
        } else {
          resolve({ x: 0, y: 0, behavior: "smooth" });
        }
      });
    });
  },
});
